module.exports = __webpack_public_path__ + "img/ic_pdf_blanc.768d010a.svg";